import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=29981c86"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkResolver: require('/home/runner/work/marketing/marketing/components/LinkResolver.vue').default,NavSubHeading: require('/home/runner/work/marketing/marketing/components/NavSubHeading.vue').default,NavHeadingLinks: require('/home/runner/work/marketing/marketing/components/NavHeadingLinks.vue').default,NavHighlight: require('/home/runner/work/marketing/marketing/components/NavHighlight.vue').default,NavHeading: require('/home/runner/work/marketing/marketing/components/NavHeading.vue').default})
